import React from 'react';
import { Box } from '@mui/material';
import Loader from './Loader';

// Whole-viewport loader shown while the app boots (see App.js). Uses the same
// polished spinner as the in-page <Loader />.
const FullPageLoader = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      backgroundColor: '#f5f7fa'
    }}
  >
    <Loader size={56} />
  </Box>
);

export default FullPageLoader;
